import { useCallback } from "react"
import { useTreeMapGraphOption } from "./options"
import { useTreeMapGraphModel } from "./model"
import { numericValueFormat } from "../../common"

type useTreeMapGraphRenderOptionProps<T> = {
	graphOption: ReturnType<typeof useTreeMapGraphOption<T>>
	graphData: ReturnType<typeof useTreeMapGraphModel<T>>
}
export const useTreeMapGraphRenderOption = <T,>({
	graphOption: {
		valueDef
	},
	graphData
}: useTreeMapGraphRenderOptionProps<T>) => {
  const valueFormatter = useCallback(
    (value: number | string) => numericValueFormat(value, 1, valueDef?.unit),
    [valueDef]
  )
  const labelFormatter = useCallback(
    (params?: {
      name: string
      value: number | string,
    }) => {
      if (!params) return undefined
      return [
        '{name|' + params.name + '}',
        '{hr|}',
        '{budget|' + valueFormatter(params.value) + '}',
      ].join('\n')
    },
    [valueFormatter]
  )
	return {
		//animation: false,
		tooltip: {
			trigger: 'item',
			axisPointer: {
				type: 'shadow',
			},
			valueFormatter
		},
		series: {
			type: 'treemap',
			nodeClick: undefined,
			name: graphData?.label,
			roam: false,
			top: 0, bottom: 10, left: 10, right: 10,
			breadcrumb: { show: false },
			emphasis: {
				itemStyle: {
					shadowBlur: 10,
					shadowOffsetX: 0,
					shadowColor: 'rgba(0, 0, 0, 0.5)',
				},
			},
			label: {
				show: true,
				position: 'insideTopLeft',
				formatter: labelFormatter,
				rich: {
					name: {
						fontSize: 10,
						color: '#fff',
					},
					hr: {
						width: '100%',
						borderColor: 'rgba(255,255,255,0.2)',
						borderWidth: 0.5,
						height: 0,
						lineHeight: 10,
					},
					budget: {
						fontSize: 12,
						color: '#fff',
					},
				},
			},
			data: graphData?.data ?? []
		},
		textStyle: {
			fontFamily: 'Noto Sans JP,sans-serif'
		}
	}
}